"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ShareButton = void 0;
var OpenFeedbackBenefitDialog = _interopRequireWildcard(require("@ori-events/open-feedback-benefit-dialog"));
var _presentationComponents = require("@ori/presentation-components");
var _react = require("react");
var _hooks = require("../../hooks");
var _useTranslations = require("../../hooks/useTranslations");
var _net = require("../../models/graphql-types/net");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const openFeedbackBenefitDialog = (detail)=>()=>{
        window.dispatchEvent(new CustomEvent(OpenFeedbackBenefitDialog.Name, {
            detail
        }));
    };
const ShareButton = exports.ShareButton = /*#__PURE__*/ (0, _react.memo)(()=>{
    const { translations } = (0, _useTranslations.useTranslations)();
    const { currentPages } = (0, _hooks.usePageNumberContext)();
    var _currentPages_;
    const cataloguePageNumber = (_currentPages_ = currentPages[0]) !== null && _currentPages_ !== void 0 ? _currentPages_ : 1;
    const { catalogueId } = (0, _hooks.useCatalogueUrlAndId)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.ShareButton, {
        "aria-label": translations.shareTheCatalogue,
        title: translations.shareTheCatalogue,
        onClick: openFeedbackBenefitDialog({
            type: _net.FeedbackBenefitBannerType.ShareAndEarn,
            cataloguePageNumber,
            catalogueId,
            gamificationActivityType: 'ShareCatalogue'
        })
    });
});
